const handleScroll = (table, header, initialTop) => {
    const { top, height } = header.getBoundingClientRect();
    const { bottom } = table.getBoundingClientRect();
    if (top <= 0 && window.scrollY > initialTop && bottom - height > 0) {
        header.style.position = "fixed";
    } else {
        header.style.position = "unset";
    }
};
export default {
    inserted(table) {
        const header = table.querySelector(".el-table__header");
        header.style.top = "0px";
        header.style.background = "white";
        header.style.zIndex = 1000;
        const initialTop = header.getBoundingClientRect().top;
        window.addEventListener(
            "scroll",
            () => {
                handleScroll(table, header, initialTop);
            },
            { passive: true },
        );
    },
    unbind() {
        window.removeEventListener("scroll", handleScroll, { passive: true });
    },
};
